<script setup>
import { onMounted } from 'vue';
import { removeToast } from '@utils/toast-util';
import Icon from '@components/icons/icon.vue';

const props = defineProps({
    uuid: {
        type: String,
        required: true,
    },
    component: {
        type: [Object, String],
        required: true,
    },
    props: {
        type: Object,
        default: () => {
            return {};
        },
    },
    context: {
        type: String,
        default: 'isSuccess',
    },
    timeout: {
        type: Number,
        default: 1500,
    },
});

const toastColor = {
    isSuccess: 'is_success',
    isError: 'is_error',
    isWarning: 'is_warning',
    isInfo: 'is_info',
};

const toastIcon = {
    isSuccess: 'check',
    isError: 'times',
    isWarning: 'exclamation-triangle',
    isInfo: 'info-circle',
};

onMounted(() => {
    setTimeout(() => {
        removeToast(props.uuid);
    }, props.timeout);
});
</script>

<template>
    <div :class="[$style.toast, $style[toastColor[context]]]">
        <Icon :class="$style.icon" :icon="toastIcon[context]" :icon-color="context === 'isWarning' ? 'default' : 'white'"/>
        <component :is="component" v-bind="props.props"/>
    </div>
</template>

<style lang="scss" module>
@use '@text' as *;
@use '@backgrounds' as *;
@use '@sizes' as *;

.toast {
    display: flex;
    align-items: center;
    max-width: max(40vw, 40em);
    padding: .6em .8em;
    margin: .25em .7em;
    font-size: $font-size-1;
    font-weight: $weight-medium;
    line-height: 1.1;
    color: #fff;
    border-radius: 1em;
    animation: scale_toast .1s linear running;

    @media (min-width: 33em) {
        margin: .35em 0;
    }
    .icon {
        margin-right: .6em;
        font-size: $font-size-2;
        line-height: 1em;
    }
    &.is_success {
        background-color: $green-background;
    }
    &.is_error {
        background-color: $red-background;
    }
    &.is_warning {
        color: $default-text-color;
        background-color: $yellow-background;
    }
    &.is_info {
        background-color: $blue-background;
    }
}

@keyframes scale_toast {
    0% {
        opacity: 0;
        transform: scale(0);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
